export const GUEST_QUERY_IDENTITY = 'guest' as const;

export function identityScopedQueryHash(
  queryKey: readonly unknown[],
  userId: string | null | undefined,
  isPublic: (queryKey: readonly unknown[]) => boolean,
): string {
  const scope = isPublic(queryKey)
    ? ['public']
    : ['private', userId ?? GUEST_QUERY_IDENTITY];
  return JSON.stringify([...scope, ...queryKey]);
}
